// OTPModal.jsx
import Modal from 'react-modal';
import Lottie from 'lottie-react';
import SuccessAnimation from "assets/images/SuccessAnimation.json"
import ErrorAnimation from "assets/images/ErrorAnimation.json"
import { Img } from 'components';
import { useEffect } from 'react';

Modal.setAppElement('#root'); // Important for accessibility

const SuccessModal = ({ isOpen, onRequestClose }) => {
       useEffect(() => {
        if (isOpen?.key) {
            const timer = setTimeout(() => {
                onRequestClose?.();
            }, 3000);

            return () => clearTimeout(timer); // Cleanup on unmount or re-render
        }
    }, [isOpen?.key]);
    return (
        <Modal
            isOpen={!!isOpen?.key}
            onRequestClose={onRequestClose}
            className="max-w-md m-auto bg-[white] rounded-3xl p-6 shadow-lg outline-none"
            overlayClassName="z-[1100] fixed inset-0 bg-[black] bg-opacity-40 flex justify-center items-start"
        >
            <>
            {/* <div className="flex justify-end">
                <button type='button' onClick={onRequestClose}><Img src={"images/Close.svg"} className='h-7' /></button>
            </div> */}
                <div className='flex flex-col items-center px-12 gap-5'>
                    {isOpen?.key === "success" ? <Lottie animationData={SuccessAnimation}  loop={false} className='max-h-[20vh]' /> : <Lottie animationData={ErrorAnimation}  loop={false} className='h-[20vh]' />} 
                    <p className='text-center font-manropeM text-[2.6vh]'>{isOpen?.message}</p>
                </div>
            {/* <button  type='button' onClick={onRequestClose} className="flex justify-center items-center gap-2 mt-5 text-sm text-smd_blue-normal hover:underline w-full text-center">
                <Img src={"images/soomuch-demo/left-arrow-blue.svg"} className='h-4' />
                <span>Go Back</span>
            </button> */}
            </>
        </Modal>
    );
};

export default SuccessModal;
